/**
 * Подписка на смену палитры — для всего, что красит себя не через CSS:
 * Clerk (`appearance`) и canvas волны плеера (#1178).
 *
 * Палитру на `<html>` задают ДВА атрибута, и следить надо за обоими.
 *
 * `ThemeProvider` пишет и класс `light`/`dark`, и `data-color-scheme`
 * (ThemeContext.tsx), а `theme.css` разводит по второму из них ощутимо разные
 * наборы: `.light[data-color-scheme='meridian']` против голого `.light` — это
 * другой фон, другой текст и другой primary. Слушая только класс, смену схемы
 * внутри одной темы мы бы пропустили, и подписчик остался бы на старой палитре
 * поверх перекрашенной страницы — ровно то расхождение, ради которого до-
 * гидрационный скрипт в index.html и начал этот атрибут выставлять.
 *
 * Отдельной подписки на `prefers-color-scheme` не нужно: в режиме Auto
 * `ThemeProvider` сам переписывает класс.
 */
export function subscribeTheme(onChange: () => void): () => void {
  if (typeof document === 'undefined' || typeof MutationObserver !== 'function') {
    return () => {};
  }
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'data-color-scheme'],
  });
  return () => observer.disconnect();
}
